module.exports = __webpack_public_path__ + "static/media/abattoir-picture-2.05c5c787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/abattoir-picture-2.jpg
// module id = 589
// module chunks = 0